<template>
<v-list class='mt-0' dense subheader>
  <v-btn
    v-if='withInlineControls'
    fab small blue absolute right ><v-icon>add</v-icon></v-btn>
  <v-subheader>{{title}}</v-subheader>
  <v-list-tile
    v-for='(code, index) in appointment.codes'
    :key='code.id'
    :disabled="deleting.indexOf(code.id) !== -1" >
    <v-list-tile-action v-if='withDelete' >
      <v-btn @click='prepareToDelete(code, index)' icon >
        <v-icon>delete</v-icon>
      </v-btn>
    </v-list-tile-action>
    <v-list-tile-content >
      <v-list-tile-title>
        {{code.icd10}}. {{code.process}}
      </v-list-tile-title>
    </v-list-tile-content>
    <v-list-tile-action >
      {{ formatCurrency( code.currency, code.price) }}
    </v-list-tile-action>
  </v-list-tile>

  <v-dialog v-model="deleteDialog" :width="300" >
    <v-card>
      <v-card-title >
        {{ $t('dialog.delete.title') }}
      </v-card-title>
      <v-card-actions >
        <v-btn @click='deleteDialog = false' flat >Cancel</v-btn>
        <v-spacer ></v-spacer>
        <v-btn
          @click='deleteCode'
          :loading='deleteRequest.loading'
          color='error' >Delete</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-list>
</template>

<script>
export default {
  name: 'AppointmentCodeList',
  props: {
    title: { type: String },
    appointment: { type: Object },
    withDelete: { type: Boolean, default: true },
    withInlineControls: { type: Boolean, default: false },
    loading: { type: Boolean, default: false }
  },
  data () {
    return {
      resource: 'appointment.codes',
      requests: {
        delete: 'appointment-codes-delete-request'
      },
      deleteLoading: false,
      deleteDialog: false,
      selectedCode: {},
      selectedCodeIndex: 0,
      deleting: []
    }
  },
  watch: {
    deleteRequestStatus () {
      if (this.deleteRequestStatus === 204) {
        this.$emit('code:deleted')
      }
      if (this.deleteRequestStatus > 299) {
        window.alert('Unable to delete code')
      }
      if (this.deleteRequestStatus > 199) {
        this.deleting = []
        this.deleteDialog = false
      }
    }
  },
  computed: {
    deleteRequest () {
      return this.$store.getters.getRequestById(this.requests.delete, true)
    },
    deleteRequestStatus () {
      return this.deleteRequest.status
    }
  },
  methods: {
    prepareToDelete (code, index) {
      this.selectedCode = code
      this.selectedCodeIndex = index
      this.deleteDialog = true
    },
    deleteCode (data) {
      let id = this.selectedCode.id
      let params = {appointment_id: this.appointment.id}
      this.deleting.push(id)
      this.$appointmentguru
        .resource(this.resource)
        .id(this.requests.delete)
        .delete(id, params)
    }
  },
  i18n: {
    messages: {
      en: {
        dialog: {
          delete: {
            title: 'Are you sure you want to delete this code?'
          }
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// AppointmentCodeList.vue?8f8c3daa